/**
 * Сроки хранения правила V2 (Part 4, раздел 3.4).
 *
 * Контракт задаёт пару, а не два независимых поля: если задан срок хранения
 * событий, срок хранения фотофиксации тоже обязан быть задан и не может его
 * превышать. Пустая пара — это «хранить по умолчанию», её backend принимает
 * как null/null.
 *
 * Валидация живёт здесь, а не в форме: те же правила нужны и при создании
 * правила, и при редактировании retention существующего.
 */

export const EMPTY_RETENTION = { eventDays: '', evidenceDays: '' };

const isBlank = (value) => value === '' || value === null || value === undefined;

const parseDays = (value) => {
  const asNumber = Number(value);
  if (!Number.isInteger(asNumber) || asNumber < 1) return null;
  return asNumber;
};

/**
 * @returns {{ valid: boolean, errors: { eventDays?: string, evidenceDays?: string } }}
 */
export const validateRetention = (retention = EMPTY_RETENTION) => {
  const { eventDays, evidenceDays } = retention;
  const errors = {};

  if (isBlank(eventDays) && isBlank(evidenceDays)) return { valid: true, errors };

  if (isBlank(eventDays)) {
    errors.eventDays = 'Укажите срок хранения событий или очистите оба поля';
  }
  if (isBlank(evidenceDays)) {
    errors.evidenceDays = 'Укажите срок хранения фото или очистите оба поля';
  }

  const event = isBlank(eventDays) ? null : parseDays(eventDays);
  const evidence = isBlank(evidenceDays) ? null : parseDays(evidenceDays);

  if (!isBlank(eventDays) && event === null) {
    errors.eventDays = 'Целое число дней, не меньше 1';
  }
  if (!isBlank(evidenceDays) && evidence === null) {
    errors.evidenceDays = 'Целое число дней, не меньше 1';
  }

  if (event !== null && evidence !== null && evidence > event) {
    errors.evidenceDays = 'Фото нельзя хранить дольше самих событий';
  }

  return { valid: Object.keys(errors).length === 0, errors };
};

/** Пустая пара уходит на backend как null/null, а не как отсутствие полей. */
export const toRetentionDto = (retention = EMPTY_RETENTION) => ({
  event_retention_days: isBlank(retention.eventDays) ? null : Number(retention.eventDays),
  evidence_retention_days: isBlank(retention.evidenceDays) ? null : Number(retention.evidenceDays),
});

export const fromRetentionDto = (rule) => ({
  eventDays: rule?.event_retention_days == null ? '' : String(rule.event_retention_days),
  evidenceDays: rule?.evidence_retention_days == null ? '' : String(rule.evidence_retention_days),
});
